import { render, staticRenderFns } from "./settingTemplate.vue?vue&type=template&id=7d3c769e&scoped=true&"
import script from "./settingTemplate.vue?vue&type=script&lang=js&"
export * from "./settingTemplate.vue?vue&type=script&lang=js&"
import style0 from "./settingTemplate.vue?vue&type=style&index=0&id=7d3c769e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3c769e",
  null
  
)

export default component.exports